export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY - HH:mm:ss";
export const DATE_TIME_FORMAT_1 = "DD/MM/YYYY HH:mm";
export const DATE_TIME_FORMAT_2 = "YYYY-MM-DDTHH:mm";
export const DATE_FORMAT_YYYYMMDD = "YYYY-MM-DD";

export const ACCESS_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
export const USER_INFO_KEY = "user_info";
export const BUCKET_URL_KEY = "bucket_url";

export const DEBOUNCE_TIMER = 300;
export const MAX_SIZE_UPLOAD = 536870912; // bytes = 512 MB

export enum Role {
  ROOT = "ROLE_ROOT",
  ADMIN = "ROLE_ADMIN",
  USER = "ROLE_USER",
  AUTHOR = "ROLE_AUTHOR",
}

export enum OrderType {
  ASC = "ASC",
  DESC = "DESC",
}

export enum MenuLabel {
  STATISTICS = "Thống Kê",
  BOOK_MANAGEMENT = "Sách của tôi",
  BANK_MANAGEMENT = "Ngân hàng",
  VOICE_TRAIN_MANAGEMENT = "Voice",
  ACCOUNT_INFO = "Thông tin tài khoản",
  WALLET_MANAGEMENT = "Ví tiền",
  WITHDRAW_MANAGEMENT = "Lịch sử rút tiền",
  FAQ_MANAGEMENT = "Câu hỏi thường gặp",
}

export enum RoutePath {
  SIGN_IN = "/login",
  GOOGLE_CONSOLE = "/google-console",
  HOME = "/",
  BOOK_MANAGEMENT = "book-management",
  BANK_MANAGEMENT = "bank-management",
  CREATE_BOOK = "create-book",
  UPDATE_BOOK = "update-book",
  UPDATE_BOOK_ID = "update-book/:bookId",
  STATISTICS = "/statistics",
  BOOK_DETAIL = "book",
  VOICE_TRAIN_MANAGEMENT = "voice-train-management",
  CREATE_VOICE = "create-voice",
  ACCOUNT_INFO = "account-info",
  WALLET_MANAGEMENT = "wallet-management",
  WITHDRAW_MANAGEMENT = "withdraw-management",
  FAQ_MANAGEMENT = "faq-management",
}
